module.exports = __webpack_public_path__ + "img/basf-logo.96c79dbd.jpg";